// Formula found here: https://no.wikipedia.org/wiki/Annuitetsl%C3%A5n

function fixedRateMonthlyPayment(
  balance: number,
  interest: number,
  months: number
): number {
  const i = interest / 100 / 12;
  const n = months;
  const P0 = balance;

  const A = (i / (1 - Math.pow(1 + i, -1 * n))) * P0;

  return Math.round(A * 100) / 100;
}

export function calculateAnnuity(
  balance: number | null | undefined,
  nominalInterestRate: number | null | undefined,
  installmentCharges: number | null | undefined,
  months: number | null | undefined
) {
  if (!balance || !nominalInterestRate || !installmentCharges || !months)
    return null;
  const annuity =
    balance > 0 && nominalInterestRate > 0 && months > 0
      ? fixedRateMonthlyPayment(balance, nominalInterestRate, months) +
        installmentCharges
      : null;
  return annuity;
}
